import React from 'react';
import styled from 'styled-components';
import { primary } from '@salutejs/plasma-core';
var CaptionBase = /*#__PURE__*/styled.span.withConfig({
  componentId: "plasma-web-core__sc-11mxs4l-0"
})(["display:flex;margin-bottom:var(--label-margin-bottom);font-size:var(--font-size);line-height:var(--line-height);font-weight:var(--plasma-typo-body-m-font-weight);color:", ";"], primary);
export var Caption = function Caption(_ref) {
  var caption = _ref.caption,
      id = _ref.id,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible;

  if (!caption || !visible) {
    return null;
  }

  return /*#__PURE__*/React.createElement(CaptionBase, {
    id: id
  }, caption);
};